import { createAction, props } from '@ngrx/store';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';


export const loadBusinessUserStatuses = createAction('[StaticData] Load BusinessUserStatuses');

export const loadBusinessUserStatusesSuccess = createAction('[StaticData] Load BusinessUserStatuses Success', props<{ response: IStaticDataResponse[] }>());

export const loadBusinessUserStatusesFailure = createAction(
  '[StaticData] Load BusinessUserStatuses Failure',
  props<{ error: IGenericError<ErrorResponse> }>()
);
